import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface BalanceVisibilityState {
  isBalanceHidden: boolean;
  toggleBalanceVisibility: () => void;
}

export const useBalanceVisibilityStore = create<BalanceVisibilityState>()(
  persist(
    (set) => ({
      isBalanceHidden: false,
      toggleBalanceVisibility: () => set((state) => ({ isBalanceHidden: !state.isBalanceHidden })),
    }),
    {
      name: 'balance-visibility',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
